import React, { Component } from 'react';

class Toelatingseisen extends Component {

  render() {
    return (
      <div className="text">
        <h1>Voorbeeld rapport</h1>
        <h2> ing. B.C. van der Staal</h2>
        <p>
          Datum rapport: {new Date().getDate() + " - " + (new Date().getMonth() + 1) + " - " + new Date().getFullYear()}
        </p>


        <h3>Totaal aantal punten</h3>

        <table className="totaaltelling">
          <tbody><tr>
            <th className="first">&nbsp;</th>
            <th>eenheden</th>
          </tr>
            <tr>
              <th>Kennis</th>
              <td>657</td>
            </tr>
            <tr>
              <th>Werkervaring</th>
              <td>8.58</td>
            </tr>
            <tr>
              <th>Gemiddeld aantal gewerkte uren per jaar</th>
              <td>1,458</td>
            </tr>
          </tbody></table>
        <table className="totaaltelling">
          <tbody><tr>
            <th className="first">&nbsp;</th>
            <th>eenheden</th>
          </tr>
            <tr>
              <th>Permanente educatie</th>
              <td>0</td>
            </tr>
            <tr>
              <th>Doorlopende werkervaring (voor doorgroei naar RO)</th>
              <td>0.00</td>
            </tr>
            <tr>
              <th>Gemiddeld aantal gewerkte uren per jaar (doorlopende werkervaring)</th>
              <td>0</td>
            </tr>
          </tbody></table>


        <h3>Persoonlijke Gegevens</h3>
        <table>
          <tbody><tr>
            <th style={{ width: '25%' }}>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
            <tr>
              <td>Titel</td>
              <td>ing.</td>
            </tr>
            <tr>
              <td>Voornaam</td>
              <td>Bout</td>
            </tr>
            <tr>
              <td>Voorletters</td>
              <td>B.C.</td>
            </tr>
            <tr>
              <td>Tussenvoegsel</td>
              <td>van der</td>
            </tr>
            <tr>
              <td>Achternaam</td>
              <td>Staal</td>
            </tr>
            <tr>
              <td>Registernummer</td>
              <td>1408</td>
            </tr>
            <tr>
              <td>Status</td>
              <td>Aspirant</td>
            </tr>
            <tr>
              <td>Adres</td>
              <td>Betonplantsoen 1</td>
            </tr>
            <tr>
              <td>Postcode</td>
              <td>7836 FG</td>
            </tr>
            <tr>
              <td>Plaats</td>
              <td>Amsterdam</td>
            </tr>
            <tr>
              <td>Telefoon prive</td>
              <td>078 5735678</td>
            </tr>
            <tr>
              <td>Telefoon mobiel</td>
              <td>06 12345678</td>
            </tr>
            <tr>
              <td>Telefoon werk</td>
              <td></td>
            </tr>
            <tr>
              <td>Email</td>
              <td>secretariaat@constructeursregister.nl</td>
            </tr>
            <tr>
              <td>Geboorte datum</td>
              <td>1964-02-29</td>
            </tr>
            <tr>
              <td>Geslacht</td>
              <td>M</td>
            </tr>
            <tr>
              <td>Bedrijfsnaam</td>
              <td>Ingenieursbureau De Ingenieur</td>
            </tr>
            <tr>
              <td>Bedrijfsadres</td>
              <td>Newtonplein 31</td>
            </tr>
            <tr>
              <td>Bedrijfspostcode</td>
              <td>2325 CH</td>
            </tr>
            <tr>
              <td>Bedrijfsplaats</td>
              <td>Hoorn</td>
            </tr>
            <tr>
              <td>Bedrijfswebsite</td>
              <td></td>
            </tr>
            <tr>
              <td>Functie</td>
              <td>Constructeur</td>
            </tr>
            <tr>
              <td>Datum aanvraag</td>
              <td></td>
            </tr>
            <tr>
              <td>Status aanvraag</td>
              <td></td>
            </tr>
          </tbody></table>



        <h3>Kennis</h3>
        <table>
          <tbody><tr>
            <th>type</th>
            <th>niveau</th>
            <th>instelling</th>
            <th>opleiding</th>
            <th>plaats</th>
            <th>land</th>
            <th>afgerond in</th>
            <th>diploma</th>
            <th>Ke's</th>
          </tr>
            <tr>
              <td>Opleiding</td>
              <td>HBO</td>
              <td>Avans Hogeschool</td>
              <td>CT/Wtb/Bk (constructief)</td>
              <td>Tilburg</td>
              <td>Nederland</td>
              <td>1988</td>
              <td>ja</td>
              <td>400</td>
            </tr>
            <tr>
              <td>Opleiding</td>
              <td>HBO</td>
              <td>Elsevier/KiVi</td>
              <td>Grondmechanica en funderingstechniek (CGF1)</td>
              <td>Zwijndrecht</td>
              <td>Nederland</td>
              <td>1991</td>
              <td>ja</td>
              <td>25</td>
            </tr>
            <tr>
              <td>Opleiding</td>
              <td>HBO+</td>
              <td>Betonvereniging</td>
              <td>Betonconstructeur BV/PMSE</td>
              <td>Gouda</td>
              <td>Nederland</td>
              <td>1995</td>
              <td>ja</td>
              <td>200</td>
            </tr>
            <tr>
              <td>Cursus</td>
              <td>HBO</td>
              <td>Betonvereniging</td>
              <td>Bijzondere constructies met EC-2</td>
              <td>Utrecht</td>
              <td>Nederland</td>
              <td>1991</td>
              <td>ja</td>
              <td>6</td>
            </tr>
            <tr>
              <td>Cursus</td>
              <td>HBO</td>
              <td>SCIA</td>
              <td>Scia Engineer</td>
              <td>Herk de Stad</td>
              <td>Belgie</td>
              <td>1995</td>
              <td>ja</td>
              <td>2</td>
            </tr>
            <tr>
              <td>Cursus</td>
              <td>HBO</td>
              <td>Bouwen met Staal</td>
              <td>Eurocode 3: Toetsing van staalconstructies (alg.)</td>
              <td>Zoetermeer</td>
              <td>NL</td>
              <td>1996</td>
              <td>ja</td>
              <td>4</td>
            </tr>
            <tr>
              <td colspan="8">
                <strong>Totaal ke's</strong>
              </td>
              <td>
                <strong>637</strong>
              </td>
            </tr>
          </tbody></table>






        <h3>Publicaties</h3>
        <table>
          <tbody><tr>
            <th>aantal</th>
            <th>vakblad</th>
            <th>jaartal</th>
            <th>beschrijving</th>
            <th>Ke's</th>
          </tr>
            <tr>
              <td>5</td>
              <td></td>
              <td>0</td>
              <td>Diverse publicaties in Cement</td>
              <td>20</td>
            </tr>
            <tr>
              <td colspan="4">
                <strong>Totaal ke's</strong>
              </td>
              <td>
                <strong>20</strong>
              </td>
            </tr>
          </tbody></table>








        <h3>Referenten</h3>
        <table>
          <tbody><tr>
            <th>Afkorting</th>
            <th>Naam</th>
            <th>E-mail</th>
            <th>Telefoon</th>
            <th>Functie</th>
          </tr>
            <tr>
              <td>REF</td>
              <td>. Naam referent</td>
              <td>info@constructeursregister.nl</td>
              <td>06-12345678</td>
              <td>Directeur</td>
            </tr>
          </tbody></table>
        <h3>Werkervaring</h3>
        <table>
          <tbody><tr>
            <th>Niveau</th>
            <th>Werkgever</th>
            <th>Opdrachtgever</th>
            <th>Soort project</th>
            <th style={{ minwidth: "15em" }}>Project</th>
            <th style={{ minwidth: "15em" }}>Locatie</th>
            <th>Jaar</th>
            <th>Uren</th>
            <th>Ingevoerde ee's</th>
            <th>Ee's akkoord</th>
            <th>Referentie</th>
            <th>Goedgekeurd op</th>
            <th>Upload</th>
            <th style={{ minwidth: "30em" }}>Omschrijving project</th>
            <th style={{ minwidth: "30em" }}>Omschrijving werkzaamheden</th>
          </tr>
            <tr>
              <td>C5</td>
              <td>Ingenieursbureau De Ingenieur</td>
              <td>Opdrachtgever F</td>
              <td>project</td>
              <td>Churchillaan in Rijswijk</td>
              <td>Churchillaan in Rijswijk</td>
              <td>2010-2012</td>
              <td>600</td>
              <td>0.45</td>
              <td>0.45</td>
              <td>REF</td>
              <td>2014-08-28</td>
              <td></td>
              <td>Drie gelijke woontorens van 15 verdiepingen waarvan de onderste drie lagen de torens met elkaar verbindt. Bijbehorende achterliggende prefab parkeergarage op de BG. Onderste drie lagen zijn in wanden-breedplaat opgezet en de torens zijn met een tunnelsysteem opgezet met meegestorte prefab balkons. De torens hebben inwendig woningscheidende betonwanden t.b.v. stabiliteit. Op de BG wordt dit een combinatie van wandschijven en kolommen.</td>
              <td>Vanaf een aangeleverd VO het bestek opgezet. Diverse ontwerpberekeningen gemaakt ter onderbouwing van het VO. Bestekteksten gecontroleerd. Bouwvergaderingen bijgewoond. Projectteam aangestuurd t.b.v. gewichts- en stabiliteitsberekening. Interne controle van berekeningen en tekeningen. </td>
            </tr>
            <tr>
              <td>C4</td>
              <td>Ingenieursbureau De Ingenieur</td>
              <td>Opdrachtgever C</td>
              <td>project</td>
              <td>B-Tower</td>
              <td>Rotterdam</td>
              <td>2004-2012</td>
              <td>700</td>
              <td>0.44</td>
              <td>0.44</td>
              <td>REF</td>
              <td>2014-08-28</td>
              <td></td>
              <td>In het centrum van Rotterdam op een prominente locatie naast rijksmonument de Bijenkorf,  nabij de Beurstraverse is de B-Tower gerealiseerd. Het project bestaat uit een woontoren van 70 m met onderin winkelruimte. De hoofddraagconstructie is geheel van beton. Enkele zwaarbelaste kolommen zijn in hogesterktebeton uitgevoerd. De stabiliteit wordt verzorgd door de betonnen kern (2 liften) in combinatie met een drietal betonwanden.
</td>
              <td>Als constructeur was ik verantwoordelijk voor het maken van de definitieve hoofdberekening van de constructie. Het maken van de gewichts- en stabiliteitsberekening en het indienen bij BoWoTo. Tevens was ik verantwoordelijk voor het wapenen van de in het werk gestorte betonwanden van de hoofddraagconstructie en het aansturen van het tekenwerk van de wandwapening. Daarnaast het verzorgen van de indiening van de wandwapening bij BoWoTo.</td>
            </tr>
            <tr>
              <td>C5</td>
              <td>Ingenieursbureau De Ingenieur</td>
              <td>Opdrachtgever D</td>
              <td>project</td>
              <td>Renovatie kantoor ASR</td>
              <td>Utrecht</td>
              <td>2011-2011</td>
              <td>750</td>
              <td>0.56</td>
              <td>0.56</td>
              <td>REF</td>
              <td>2014-08-28</td>
              <td></td>
              <td>Renovatie en uitbreiding bestaande kantoorgebouw ASR (voorheen AMEV). Gehele gebouw inclusief bestaande gevel wordt gestript waarna enkel de constructie resteert. In de constructie worden grote vides gerealiseerd op constructief complexe posities. Hierdoor worden divers constructieve versterkingen noodzakelijk. Op het bestaande gebouw worden diverse verticale uitbreidingen gerealiseerd,  waardoor de bestaande constructie zwaarder belast zal worden. Tegen het bestaande gebouw wordt een nieuwe kelder aangebracht welke aansluit op de bestaande kelder. Het niveau van het grondwater bepaald de constructieopzet en de keuze van bouwput. (onderwaterbeton,  groutlichamen en tijdelijke en permanente damwanden). De nieuwe glasgevel (in zaagtandvorm) geeft een transparant karakter aan het gebouw. De nieuw te ontwerpen installaties maken diverse grote sparingen in de hoofddraagconstructie noodzakelijk.</td>
              <td>Rol: Projectleider. Maken van ontwerp-berekeningen van de gehele hoofddraagconstructie,  inclusief controle bestaande constructies. Begeleiden tekenwerk.</td>
            </tr>
            <tr>
              <td>C5</td>
              <td>Ingenieursbureau De Ingenieur</td>
              <td>Opdrachtgever E</td>
              <td>project</td>
              <td>Techniekruimte LBH kasten voor OK complex CWZ</td>
              <td>Nijmegen</td>
              <td>2009-2011</td>
              <td>110</td>
              <td>0.08</td>
              <td>0.08</td>
              <td>REF</td>
              <td>2014-08-28</td>
              <td></td>
              <td>Op het dak van het CWZ moet de techniekruimte worden uitgebreid tbv installaties voor de onderliggende OK ruimtes. Het dak bestaat uit een puntvormig ondersteunde breedplaatvloer met een overspanning van 7,  2 meter. Deze breedplaatvloer heeft onvoldoende capaciteit om de belasting uit de stalen dakopbouw en de installaties van de nieuwe techniekruimte te kunnen dragen. Er is een constructie ontworpen om de belasting rechtstreeks op de betonkolommen onderdaks af te dragen. Bovendien moeten er voor doorvoer van leidingen forse sparingen in het betondak aangebracht worden. De capaciteit van het dak is hiervoor onvoldoende. Dit is opgelost door het dak aan de onderzijde te verstevigen met koolstoflijmwapening. Oppervlak uitbreiding techniekruimte: 400m2 </td>
              <td>1) Het opstellen van een constructief VO en dit verder uitwerken tot een DO en daarna bestek; 2) Opstellen van alle benodigde berekeningen (stabiliteitsberekening,  gewichtsberekening,  controle van de bestaande betonconstructie op de extra belasting en sparingen en berekening staalconstructie) voor indiening bij Bouw- en woningtoezicht; 3) Overleg met opdrachtgever en adviseurs; 4) Aansturen tekenwerk in bestek- en uitvoeringsfase; 5) Maken van de detailberekeningen in de uitvoeringsfase; 6) Toezicht tijdens de uitvoering van de hoofddraagconstructie en bijwonen van bouwvergaderingen; 7) Eigen verantwoordelijkheid voor ontwerp,  berekening van de hoofddraagconstructie en details. </td>
            </tr>
            <tr>
              <td>C5</td>
              <td>Ingenieursbureau De Ingenieur</td>
              <td>Opdrachtgever X</td>
              <td>project</td>
              <td>Nieuwbouw/renovatie Flat 40</td>
              <td>Zeist</td>
              <td>2009-2011</td>
              <td>850</td>
              <td>0.64</td>
              <td>0.64</td>
              <td>REF</td>
              <td>2014-08-28</td>
              <td></td>
              <td>Het bestaande flat wordt volledig gerenoveerd. Er worden op het bestaande flat 2 lagen toegevoegd en naast het bestaande flat wordt deel nieuw gebouwd (23 woningen op een parkeerlaag).</td>
              <td>Voor dit project is eerst de bestaande constructie grondig onderzocht,  omdat dit een flat is volgens het principe Schokbeton uit de jaren '70. Hierdoor zijn er diverse beperkingen aanwezig voor wat betreft de mogelijke aanpassingen. Er een ontwerp gemaakt voor wat betreft de aanpassingen aan de bestaande bouw en de nieuwbouw. Er is veel overleg gevoerd met de architect en de opdrachtgever. Het project is inmiddels qua ontwerp volledig afgerond. Het wachten is nu op het opstarten van de uitvoering.</td>
            </tr>
            <tr>
              <td>C3</td>
              <td>Ingenieursbureau De Ingenieur</td>
              <td>Opdrachtgever A</td>
              <td>project</td>
              <td>Matrixgebouw</td>
              <td>Hilversum</td>
              <td>2003-2005</td>
              <td>110</td>
              <td>0.06</td>
              <td>0.06</td>
              <td>REF</td>
              <td>2014-08-28</td>
              <td></td>
              <td>Het project betreft een kantoorgebouw met 5 verdiepingen. Architect: KCAP architects te Rotterdam. De constructie bestaat uit een Prefab betonskelet welke op staal is gefundeerd. Zie ook de omschrijving en tekeningen in de bijlage. </td>
              <td>Mijn werkzaamheden en bijbehorende verantwoordelijkheid voor dit project zijn: DO en besteksfase: -Gewichts- en stabiliteitsberekening-Bepalen constructie afmetingen. -Bepalen voorzieningen voor de trekband,  dwarskrachtkoppelingenetc. Uitvoeringsfase: -Berekenen wapening fundering. -Belastingopgave tbv leveranciers vloeren -Controle constructieve berekeningen derden -Constructief begeleiden Aannemer. -Indienen stukken en contact met BWT. -Berekenen van de wapening voor de prefab-leverancier.</td>
            </tr>
            <tr>
              <td>C5</td>
              <td>Ingenieursbureau De Ingenieur</td>
              <td>Diverse opdrachtgevers</td>
              <td>geclusterde opdracht</td>
              <td>Diverse projecten</td>
              <td>Diverse locaties</td>
              <td>2007-2010</td>
              <td>3800</td>
              <td>2.85</td>
              <td>2.85</td>
              <td>REF</td>
              <td>2014-08-28</td>
              <td></td>
              <td>De bijgevoegde projectenlijst bevat utilitaire werken van verschillende aard,  variërend van nieuwbouw van ziekenhuis tot petrochemische plant. </td>
              <td>Mijn rol was het ontwerpen en berekenen van de hoofddraagconstructies,  zowel in staal,  beton en hout,  alsmede het ontwerpen en berekenen van de fundatie en beschouwing en berekening van de stabiliteit. Ook het maken van definitieve (hoofd)berekeningen en wapeningsberekeningen behoorden tot mijn werkzaamheden. </td>
            </tr>
            <tr>
              <td>C4</td>
              <td>Ingenieursbureau De Ingenieur</td>
              <td>Diverse opdrachtgevers</td>
              <td>geclusterde opdracht</td>
              <td>Diverse projecten</td>
              <td>Diverse locaties</td>
              <td>2005-2007</td>
              <td>3200</td>
              <td>2.00</td>
              <td>2.00</td>
              <td>REF</td>
              <td>2014-08-28</td>
              <td></td>
              <td>De projectenlijst welke is bijgevoegd,  bevat utilitaire werken van verschillende aard,  variërend van nieuwbouw van het UMCG tot een clubhuis van de Drentsche Golf &amp; Country club. </td>
              <td>Deze projecten behoren tot mijn eerste werkzaamheden als constructeur. Ik was verantwoordelijk voor het maken van de definitieve hoofdberekeningen van de constructie en tevens voor de wapeningsberekeningen van de in het werk gestorte betonconstructies. Onze rol bij al deze projecten,  was die van hoofdconstructeur. </td>
            </tr>
            <tr>
              <td>C3</td>
              <td>Ingenieursbureau De Ingenieur</td>
              <td>Diverse opdrachtgevers</td>
              <td>geclusterde opdracht</td>
              <td>Diverse projecten</td>
              <td>Diverse locaties</td>
              <td>2003-2005</td>
              <td>3000</td>
              <td>1.50</td>
              <td>1.50</td>
              <td>REF</td>
              <td>2014-08-28</td>
              <td></td>
              <td>ja 	Zie de bijgevoegde projectenlijst. De werken bevatten onder andere 1) Woningbouw variërend van aanbouw tot woningblokken,  2) utiliteitsbouw 3) geotechnische berekeningen,  zoals paaldraagvermogen,  damwanden 4) civiele werken,  zoals keermuren,  bruggen en funderingen. </td>
              <td>Bij deze projecten was ik verantwoordelijk voor het maken van de definitieve hoofdberekeningen van de constructie en tevens voor de wapeningsberekeningen van de in het werk gestorte betonconstructies. Verder bij de wat complexere staalconstructies verzorgde ik de detailberekeningen van het staal,  zoals momentvaste verbindingen en verbindingen met eisen i.v.m. brandomstandigheden. Daarnaast was een taak de controle van constructieve stukken (tekeningen en berekeningen) van leveranciers.</td>
            </tr>
            <tr>
              <td colspan="7">
                <strong>C4- ee's</strong>
              </td>
              <td>
                <strong>3110</strong>
              </td>
              <td>
                <strong>(1.56)</strong>
              </td>
              <td>
                <strong>1.56</strong>
              </td>
              <td colspan="5">&nbsp;
    </td>
            </tr>
            <tr>
              <td colspan="7">
                <strong>C4+ ee's</strong>
              </td>
              <td>
                <strong>10010</strong>
              </td>
              <td>
                <strong>(7.02)</strong>
              </td>
              <td>
                <strong>7.02</strong>
              </td>
              <td colspan="5">&nbsp;
    </td>
            </tr>
            <tr>
              <td colspan="7">
                <strong>O ee's</strong>
              </td>
              <td>
                <strong>0</strong>
              </td>
              <td>
                <strong>(0.00)</strong>
              </td>
              <td>
                <strong>0.00</strong>
              </td>
              <td colspan="5">&nbsp;
    </td>
            </tr>
            <tr>
              <td colspan="7">
                <strong>CC1 &amp; CC2a ee's</strong>
              </td>
              <td>
                <strong>0</strong>
              </td>
              <td>
                <strong>(0.00)</strong>
              </td>
              <td>
                <strong>0.00</strong>
              </td>
              <td colspan="5">&nbsp;
        </td>
            </tr>
            <tr>
              <td colspan="7">
                <strong>CC2b &amp; CC3 ee's</strong>
              </td>
              <td>
                <strong>0</strong>
              </td>
              <td>
                <strong>(0.00)</strong>
              </td>
              <td>
                <strong>0.00</strong>
              </td>
              <td colspan="5">&nbsp;
        </td>
            </tr>
            <tr>
              <td colspan="7">
                <strong>Totaal ee's</strong>
              </td>
              <td>
                <strong>13120</strong>
              </td>
              <td>
                <strong>(8.58)</strong>
              </td>
              <td>
                <strong>8.58</strong>
              </td>
              <td colspan="5">&nbsp;
    </td>
            </tr>
          </tbody></table>
























        <h3>Totaaltelling punten O-ervaring</h3>
        <table>
          <tbody><tr><th>&nbsp;</th>
            <th>eenheden</th>
          </tr>
            <tr>
              <th>Totaaltelling ingevoerde O ee's</th>
              <td>0.00</td>
            </tr>
          </tbody></table>



      </div>
    );
  }
}

export default Toelatingseisen;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/RaportExample.js